<template>
    <component :is="typeToComponent"
               :color="color"
               :size="size"
               style="overflow: visible;">
        <v-img v-if="rank && rank.icon"
               :src="rank.icon"
               :width="size/2"
               contain
               style="position: absolute; right: 0; bottom: 0; z-index: 100; transform: translate(25%, 25%)"></v-img>

        <img v-if="user && avatarImage"
             :src="avatarImage"
             :alt="fullName">

        <span class="white--text"
              v-else-if="user">
            {{ initials }}
        </span>
    </component>
</template>
<script>
    import Achievement from '../models/Achievement';
    // 3rd
    import {
        VAvatar,
        VListItemAvatar
    } from 'vuetify/lib';
    // models
    import Rank from '../models/Rank';

    export default {
        name: 'user-avatar',
        components: {
            VListItemAvatar,
            VAvatar,
        },
        props: {
            type: {
                default: 'default', // default, list
                type: String,
            },
            size: {
                default: 35,
                type: Number,
            },
            color: {
                default: 'primary darken-1',
            },
            user: {
                required: true,
            },
        },
        mounted() {
        },
        computed: {
            achievements() {
                return Achievement.getAll();
            },
            typeToComponent() {
                if (this.type === 'list') {
                    return 'v-list-item-avatar';
                } else {
                    return 'v-avatar';
                }
            },
            rank() {
                return Achievement.getHighestRank();
            },
            avatarImage() {
                return this.user.profile.avatar_url;
            },
            fullName() {
                return `${this.user.first_name} ${this.user.last_name}`;
            },
            initials() {
                return `${this.user.first_name[0]}${this.user.last_name[0]}`;
            },
        },
    }
</script>
